import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormControl, Validators, NgForm } from '@angular/forms';
import { VideoService } from 'src/app/service/video/video.service';
import { VgApiService } from '@videogular/ngx-videogular/core';
import { AuthenticationService } from 'src/app/service/translate/authentication.service';
import { Store, select } from '@ngrx/store';
import { IAppState } from 'src/app/store/state/app.state';
import { selectIp } from 'src/app/store/selectors/page.selectors';
import { PageGetIp } from 'src/app/store/actions/page.actions';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss'],
})
export class VideoComponent implements OnInit {
  ipObs$ = this._store.pipe(select(selectIp));

  model = {
    cid: null,
    ip: null,
    meeting: null,
  };

  @ViewChild('myMedia', { static: true }) myVideo: ElementRef;

  api: VgApiService;

  constructor(
    public videoService: VideoService,
    public authenticationService: AuthenticationService,
    private _store: Store<IAppState>
  ) {}

  ngOnInit(): void {
    this.ipObs$.subscribe((x) => {
      if (x && x !== '') {
        this.model.ip = x;
        this.model.meeting = 0;
        if (environment.production) {
          this.model.cid = 'AB396718-9768-406F-8320-BEA0E940CB75';
        } else {
          this.model.cid = '2F1ABD87-5863-4BCA-BEA8-155E4CA42741';
        }

        this.videoService.getVideoUrl(this.model);
      }
    });
    this._store.dispatch(new PageGetIp());
  }

  onPlayerReady(api: VgApiService) {
    this.api = api;
    this.api.getDefaultMedia().subscriptions.canPlayThrough.subscribe(() => {
      if (this.myVideo.nativeElement.muted) {
        this.api.volume = 0;
      }
    });
  }

  resetForm(form: NgForm) {
    form.form.reset();
  }

  createLink() {
    if (this.model.ip && this.model.ip !== '') {
      this.videoService.getVideoUrl(this.model);
    }
  }

  /* To copy Text from Textbox */
  copyInputMessage(val: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }
}
